import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-360-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-360-svg-icon.component.html',
  styleUrl: './ln-360-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Ln360SvgIconComponent {
  @Input() class = 'w-8 h-8';
}
